import React from 'react';
import { Modal } from 'antd';
import breadcrumbs from 'assets/img/breadcrumbs.svg';
import style from './index.module.scss';

interface IModalLayoutProps {
	setIsShowModal: () => void;
	isVisible: boolean;
	width?: string;
}

const ModalLayout: React.FC<IModalLayoutProps> = ({ setIsShowModal, isVisible, width = '85%', children }) => {
	return (
		<Modal
			bodyStyle={{ padding: '24px 0 0 0' }}
			visible={isVisible}
			onCancel={setIsShowModal}
			width={width}
			closeIcon={
				<svg className={style.icon}>
					<use xlinkHref={`${breadcrumbs}#crossMark`} />
				</svg>
			}
			destroyOnClose={true}
			footer={null}>
			{children}
		</Modal>
	);
};

export default ModalLayout;
